import { TextInputField } from "@sainsburys-tech/luna-form";
import { Form } from "@sainsburys-tech/luna-form";
import { Container, GridItem, GridWrapper } from "@sainsburys-tech/luna-grid";
import { FC, useEffect, useState } from "react";
import {
  DimensionLengthUOMOptions,
  DimensionWeightUOMOptions,
  FIELDS,
  FormInputLevels,
  ProductGroupOptions,
} from "../../../Interfaces/Product/IProductFormField";
import { ProductFormProps } from "../../../Types/Product/ProductFormProps";
import ActionButton from "../../SharedComponents/ActionButton";
import { useSelector } from "react-redux";
import { CheckboxField } from "@sainsburys-tech/luna-form";
import { Heading6 } from "@sainsburys-tech/luna-typography";
import { SelectField } from "@sainsburys-tech/luna-form";
import { UI_CONSTANTS } from "../../../Constants/constants";

const MeasurementsForm: FC<ProductFormProps> = (props) => {
  const payload = useSelector((state: any) => state.popupReducer);
  const numToStringReplacer = (key: any, value: any) => {
    if (typeof value === "number") {
      return value?.toString();
    }
    return value;
  };

  const isInitialState =
    JSON.stringify(payload?.data?.editPayload?.values, numToStringReplacer) ===
    JSON.stringify(props.values, numToStringReplacer);

  return (
    <>
      <Container>
        <Form className="o-form">
          <GridWrapper className="ln-u-push-bottom">
            <GridItem size={{ md: "1/4", sm:"1/3", xs: "1" }}>
              <TextInputField
                name={FIELDS.sainId.name}
                label={FormInputLevels.SainId}
                maxLength={128}
                value={props.values.sainId}
                disabled
              />
            </GridItem>
            <GridItem size={{ md: "1/4", sm:"1/3", xs: "1" }}>
              <TextInputField
                name="displayItemNumber"
                label={FormInputLevels.DisplayItemNumber}
                value={
                  props.values.skuNumber
                    ? props.values.skuNumber
                    : props.values.catNumber
                }
                disabled={true}
              />
            </GridItem>
            <GridItem size={{ md: "1/4", sm:"1/3", xs: "1" }}>
              <TextInputField
                name={FIELDS.description.name}
                label={FormInputLevels.Description}
                maxLength={128}
                value={props.values.description}
                disabled={true}
              />
            </GridItem>
            <GridItem size={{ md: "1/4", sm:"1/3", xs: "1" }}>
              <TextInputField
                name={FIELDS.packSize.name}
                label={FormInputLevels.PackSize}
                value={
                  props.values.alias === UI_CONSTANTS.SAINSBURYS_SKU ||
                  props.values.alias === UI_CONSTANTS.SAINSBURYS_PACK
                    ? `CS${props.values.packSize}`
                    : props.values.alias === UI_CONSTANTS.ARGOS
                    ? (props.values.packSize == 1) ? `EA` : `CS${props.values.packSize}`
                    : props.values.packSize
                }
                disabled
              />
            </GridItem>
          </GridWrapper>
          {props.values.alias !== UI_CONSTANTS.ARGOS && (
            <>
              <Heading6 element="div">Breakpack Dimensions</Heading6>
              <GridWrapper className="ln-u-push-bottom">
                <GridItem size={{ md: "1/4", sm:"1/3", xs: "1" }}>
                  <TextInputField
                    name={FIELDS.outerDimensions.ti.name}
                    label={FormInputLevels.OuterTi}
                    maxLength={128}
                    value={props.values.outerDimensions?.ti}
                    error={props.errors?.outerDimensions?.ti}
                    onBlur={props.onBlur}
                    onChange={props.onChange}
                    disabled={!props.values.breakPackIndicator}
                  />
                </GridItem>
                <GridItem size={{ md: "1/4", sm:"1/3", xs: "1" }}>
                  <TextInputField
                    name={FIELDS.outerDimensions.hi.name}
                    label={FormInputLevels.OuterHi}
                    maxLength={128}
                    value={props.values.outerDimensions?.hi}
                    error={props.errors?.outerDimensions?.hi}
                    onBlur={props.onBlur}
                    onChange={props.onChange}
                    disabled={!props.values.breakPackIndicator}
                  />
                </GridItem>
                <GridItem size={{ md: "1/4", sm:"1/3", xs: "1" }}>
                  <TextInputField
                    name={FIELDS.outerDimensions.breakPackQty.name}
                    label={FormInputLevels.OuterQty}
                    maxLength={128}
                    value={props.values.outerDimensions?.breakPackQty}
                    error={props.errors?.outerDimensions?.breakPackQty}
                    onBlur={props.onBlur}
                    onChange={props.onChange}
                    disabled={!props.values.breakPackIndicator}
                  />
                </GridItem>
                <GridItem size={{ md: "1/4", sm:"1/3", xs: "1" }}>
                  <CheckboxField
                    label={FormInputLevels.BreakPack}
                    name={FIELDS.breakPackIndicator.name}
                    outlined
                    defaultChecked={props.values.breakPackIndicator}
                    options={[
                      {
                        value: true,
                        label: "",
                      },
                    ]}
                    error={props.errors?.breakPackIndicator}
                    onClick={(e: any) => {
                      props.onChange(e, "", "", true);
                    }}
                  />
                </GridItem>
                <GridItem size={{ md: "1/4", sm:"1/3", xs: "1" }}>
                  <TextInputField
                    name={FIELDS.outerDimensions.length.name}
                    label={FormInputLevels.OuterLength}
                    maxLength={128}
                    value={props.values.outerDimensions?.length}
                    error={props.errors?.outerDimensions?.length}
                    warning={
                      props.errors?.outerDimensions?.length
                        ? ""
                        : props.warnings?.outerDimensions?.length
                    }
                    onBlur={props.onBlur}
                    onChange={props.onChange}
                    disabled={!props.values.breakPackIndicator}
                    required
                  />
                </GridItem>
                <GridItem size={{ md: "1/4", sm:"1/3", xs: "1" }}>
                  <SelectField
                    name={FIELDS.outerDimensions.lengthUOM.name}
                    label={FormInputLevels.OuterLengthUOM}
                    options={DimensionLengthUOMOptions}
                    defaultValue={props.values.outerDimensions?.lengthUOM}
                    onChange={props.onChange}
                    onBlur={props.onBlur}
                    disabled={!props.values.breakPackIndicator}
                    placeholder={false}
                  />
                </GridItem>
                <GridItem size={{ md: "1/4", sm:"1/3", xs: "1" }}>
                  <TextInputField
                    name={FIELDS.outerDimensions.width.name}
                    label={FormInputLevels.OuterWidth}
                    maxLength={128}
                    value={props.values.outerDimensions?.width}
                    error={props.errors?.outerDimensions?.width}
                    warning={
                      props.errors?.outerDimensions?.width
                        ? ""
                        : props.warnings?.outerDimensions?.width
                    }
                    onBlur={props.onBlur}
                    onChange={props.onChange}
                    disabled={!props.values.breakPackIndicator}
                    required
                  />
                </GridItem>
                <GridItem size={{ md: "1/4", sm:"1/3", xs: "1" }}>
                  <SelectField
                    name={FIELDS.outerDimensions.widthUOM.name}
                    label={FormInputLevels.OuterWidthUOM}
                    options={DimensionLengthUOMOptions}
                    defaultValue={props.values.outerDimensions?.widthUOM}
                    onChange={props.onChange}
                    onBlur={props.onBlur}
                    disabled={!props.values.breakPackIndicator}
                    placeholder={false}
                  />
                </GridItem>
                <GridItem size={{ md: "1/4", sm:"1/3", xs: "1" }}>
                  <TextInputField
                    name={FIELDS.outerDimensions.height.name}
                    label={FormInputLevels.OuterHeight}
                    maxLength={128}
                    value={props.values.outerDimensions?.height}
                    error={props.errors?.outerDimensions?.height}
                    onBlur={props.onBlur}
                    onChange={props.onChange}
                    disabled={!props.values.breakPackIndicator}
                    required
                  />
                </GridItem>
                <GridItem size={{ md: "1/4", sm:"1/3", xs: "1" }}>
                  <SelectField
                    name={FIELDS.outerDimensions.heightUOM.name}
                    label={FormInputLevels.OuterHeightUOM}
                    options={DimensionLengthUOMOptions}
                    defaultValue={props.values.outerDimensions?.heightUOM}
                    onChange={props.onChange}
                    onBlur={props.onBlur}
                    disabled={!props.values.breakPackIndicator}
                    placeholder={false}
                  />
                </GridItem>
                <GridItem size={{ md: "1/4", sm:"1/3", xs: "1" }}>
                  <TextInputField
                    name={FIELDS.outerDimensions.weight.name}
                    label={FormInputLevels.OuterWeight}
                    maxLength={128}
                    value={props.values.outerDimensions?.weight}
                    error={props.errors?.outerDimensions?.weight}
                    onBlur={props.onBlur}
                    onChange={props.onChange}
                    disabled={!props.values.breakPackIndicator}
                    required
                  />
                </GridItem>
                <GridItem size={{ md: "1/4", sm:"1/3", xs: "1" }}>
                  <SelectField
                    name={FIELDS.outerDimensions.weightUOM.name}
                    label={FormInputLevels.OuterWeightUOM}
                    options={DimensionWeightUOMOptions}
                    defaultValue={props.values.outerDimensions?.weightUOM}
                    onChange={props.onChange}
                    onBlur={props.onBlur}
                    disabled={!props.values.breakPackIndicator}
                    placeholder={false}
                  />
                </GridItem>
              </GridWrapper>
            </>
          )}
          <Heading6 element="div">
            {props.values.alias !== UI_CONSTANTS.ARGOS ? "Case " : ""}Dimensions
          </Heading6>
          <GridWrapper className="ln-u-push-bottom">
            <GridItem size={{ md: "1/4", sm:"1/3", xs: "1" }}>
              <TextInputField
                name={FIELDS.innerDimensions.ti.name}
                label={FormInputLevels.InnerTi}
                maxLength={128}
                value={props.values.innerDimensions?.ti}
                error={props.errors?.innerDimensions?.ti}
                onBlur={props.onBlur}
                onChange={props.onChange}
                required
              />
            </GridItem>
            <GridItem size={{ md: "1/4", sm:"1/3", xs: "1" }}>
              <TextInputField
                name={FIELDS.innerDimensions.hi.name}
                label={FormInputLevels.InnerHi}
                maxLength={128}
                value={props.values.innerDimensions?.hi}
                error={props.errors?.innerDimensions?.hi}
                onBlur={props.onBlur}
                onChange={props.onChange}
                required
              />
            </GridItem>
            <GridItem size={{ md: "1/4", sm:"1/3", xs: "1" }}>
              <TextInputField
                name={FIELDS.innerDimensions.length.name}
                label={FormInputLevels.InnerLength}
                maxLength={128}
                value={props.values.innerDimensions?.length}
                error={props.errors?.innerDimensions?.length}
                onBlur={props.onBlur}
                onChange={props.onChange}
                required
              />
            </GridItem>
            <GridItem size={{ md: "1/4", sm:"1/3", xs: "1" }}>
              <SelectField
                name={FIELDS.innerDimensions.lengthUOM.name}
                label={FormInputLevels.InnerLengthUOM}
                options={DimensionLengthUOMOptions}
                defaultValue={props.values.innerDimensions?.lengthUOM}
                onChange={props.onChange}
                onBlur={props.onBlur}
                placeholder={false}
              />
            </GridItem>
            <GridItem size={{ md: "1/4", sm:"1/3", xs: "1" }}>
              <TextInputField
                name={FIELDS.innerDimensions.width.name}
                label={FormInputLevels.InnerWidth}
                maxLength={128}
                value={props.values.innerDimensions?.width}
                error={props.errors?.innerDimensions?.width}
                onBlur={props.onBlur}
                onChange={props.onChange}
                required
              />
            </GridItem>
            <GridItem size={{ md: "1/4", sm:"1/3", xs: "1" }}>
              <SelectField
                name={FIELDS.innerDimensions.widthUOM.name}
                label={FormInputLevels.InnerWidthUOM}
                options={DimensionLengthUOMOptions}
                defaultValue={props.values.innerDimensions?.widthUOM}
                onChange={props.onChange}
                onBlur={props.onBlur}
                placeholder={false}
              />
            </GridItem>
            <GridItem size={{ md: "1/4", sm:"1/3", xs: "1" }}>
              <TextInputField
                name={FIELDS.innerDimensions.height.name}
                label={FormInputLevels.InnerHeight}
                maxLength={128}
                value={props.values.innerDimensions?.height}
                error={props.errors?.innerDimensions?.height}
                onBlur={props.onBlur}
                onChange={props.onChange}
                required
              />
            </GridItem>
            <GridItem size={{ md: "1/4", sm:"1/3", xs: "1" }}>
              <SelectField
                name={FIELDS.innerDimensions.heightUOM.name}
                label={FormInputLevels.InnerHeightUOM}
                options={DimensionLengthUOMOptions}
                defaultValue={props.values.innerDimensions?.heightUOM}
                onChange={props.onChange}
                onBlur={props.onBlur}
                placeholder={false}
              />
            </GridItem>
            <GridItem size={{ md: "1/4", sm:"1/3", xs: "1" }}>
              <TextInputField
                name={FIELDS.innerDimensions.weight.name}
                label={FormInputLevels.InnerWeight}
                maxLength={128}
                value={props.values.innerDimensions?.weight}
                error={props.errors?.innerDimensions?.weight}
                onBlur={props.onBlur}
                onChange={props.onChange}
                required
              />
            </GridItem>
            <GridItem size={{ md: "1/4", sm:"1/3", xs: "1" }}>
              <SelectField
                name={FIELDS.innerDimensions.weightUOM.name}
                label={FormInputLevels.InnerWeightUOM}
                options={DimensionWeightUOMOptions}
                defaultValue={props.values.innerDimensions?.weightUOM}
                onChange={props.onChange}
                onBlur={props.onBlur}
                placeholder={false}
              />
            </GridItem>
          </GridWrapper>
        </Form>
        <ActionButton
          onSubmit={props.onSubmit}
          onClearAll={props.onClearAll}
          onCancel={props.onCancel}
          isAddDisabled={isInitialState}
          isDirty={props.dirty}
          isEdit={props.isEdit}
          isClearButtonRequired={false}
          submitted={props.submitted}
        />
      </Container>
    </>
  );
};

export default MeasurementsForm;
